export const feeCurrencyDirectoryABI = [
    {
        stateMutability: 'nonpayable',
        type: 'constructor',
        inputs: [{ name: 'test', internalType: 'bool', type: 'bool' }],
    },
    {
        type: 'event',
        anonymous: false,
        inputs: [
            { name: 'token', internalType: 'address', type: 'address', indexed: true },
            { name: 'oracle', internalType: 'address', type: 'address', indexed: true },
            { name: 'intrinsicGas', internalType: 'uint256', type: 'uint256', indexed: false },
        ],
        name: 'CurrencyConfigSet',
    },
    {
        type: 'event',
        anonymous: false,
        inputs: [{ name: 'token', internalType: 'address', type: 'address', indexed: true }],
        name: 'CurrencyRemoved',
    },
    {
        type: 'event',
        anonymous: false,
        inputs: [
            { name: 'previousOwner', internalType: 'address', type: 'address', indexed: true },
            { name: 'newOwner', internalType: 'address', type: 'address', indexed: true },
        ],
        name: 'OwnershipTransferred',
    },
    {
        stateMutability: 'view',
        type: 'function',
        inputs: [{ name: '', internalType: 'address', type: 'address' }],
        name: 'currencies',
        outputs: [
            { name: 'oracle', internalType: 'address', type: 'address' },
            { name: 'intrinsicGas', internalType: 'uint256', type: 'uint256' },
        ],
    },
    {
        stateMutability: 'view',
        type: 'function',
        inputs: [],
        name: 'initialized',
        outputs: [{ name: '', internalType: 'bool', type: 'bool' }],
    },
    {
        stateMutability: 'view',
        type: 'function',
        inputs: [],
        name: 'owner',
        outputs: [{ name: '', internalType: 'address', type: 'address' }],
    },
    {
        stateMutability: 'nonpayable',
        type: 'function',
        inputs: [],
        name: 'renounceOwnership',
        outputs: [],
    },
    {
        stateMutability: 'nonpayable',
        type: 'function',
        inputs: [{ name: 'newOwner', internalType: 'address', type: 'address' }],
        name: 'transferOwnership',
        outputs: [],
    },
    { stateMutability: 'nonpayable', type: 'function', inputs: [], name: 'initialize', outputs: [] },
    {
        stateMutability: 'nonpayable',
        type: 'function',
        inputs: [
            { name: 'token', internalType: 'address', type: 'address' },
            { name: 'oracle', internalType: 'address', type: 'address' },
            { name: 'intrinsicGas', internalType: 'uint256', type: 'uint256' },
        ],
        name: 'setCurrencyConfig',
        outputs: [],
    },
    {
        stateMutability: 'nonpayable',
        type: 'function',
        inputs: [
            { name: 'token', internalType: 'address', type: 'address' },
            { name: 'index', internalType: 'uint256', type: 'uint256' },
        ],
        name: 'removeCurrencies',
        outputs: [],
    },
    {
        stateMutability: 'pure',
        type: 'function',
        inputs: [],
        name: 'getVersionNumber',
        outputs: [
            { name: '', internalType: 'uint256', type: 'uint256' },
            { name: '', internalType: 'uint256', type: 'uint256' },
            { name: '', internalType: 'uint256', type: 'uint256' },
            { name: '', internalType: 'uint256', type: 'uint256' },
        ],
    },
    {
        stateMutability: 'view',
        type: 'function',
        inputs: [],
        name: 'getCurrencies',
        outputs: [{ name: '', internalType: 'address[]', type: 'address[]' }],
    },
    {
        stateMutability: 'view',
        type: 'function',
        inputs: [{ name: 'token', internalType: 'address', type: 'address' }],
        name: 'getCurrencyConfig',
        outputs: [
            {
                name: '',
                internalType: 'struct IFeeCurrencyDirectory.CurrencyConfig',
                type: 'tuple',
                components: [
                    { name: 'oracle', internalType: 'address', type: 'address' },
                    { name: 'intrinsicGas', internalType: 'uint256', type: 'uint256' },
                ],
            },
        ],
    },
    {
        stateMutability: 'view',
        type: 'function',
        inputs: [{ name: 'token', internalType: 'address', type: 'address' }],
        name: 'getExchangeRate',
        outputs: [
            { name: 'numerator', internalType: 'uint256', type: 'uint256' },
            { name: 'denominator', internalType: 'uint256', type: 'uint256' },
        ],
    },
];
